import { getAmountWithCurrency, useTranslation } from '@pascal/pascal-core';
import boxImgGame from '../../../../assets/images/pascal/game-pop-img3.png';
import { globalTranslationKeys } from '../../../../enums';

export const WinNotification = ({ winAmount }) => {
  const t = useTranslation();
  const { YouWin } = globalTranslationKeys;
  return (
    <div className='pascal-game-col-popup'>
      <div className='pascal-game-col-popup-content'>
        <div className='pascal-game-col-popup-ins'>
          <img src={boxImgGame} alt='' />
          <p className='pascal-game-col-popup-text'>{t(YouWin)}</p>
        </div>
      </div>
      <p className='pascal-game-col-popup-amount'>
        {getAmountWithCurrency({
          amount: +winAmount,
        })}
      </p>
    </div>
  );
};
